module.exports = __webpack_public_path__ + "img/mobilehardware2.19e944ee.png";